import { gql } from "@apollo/client";

// export const FETCH_EPISODES_BY_SEASON_ID = gql`
//     query FetchEpisodesBySeasonId($season_id:String!) {
//     fetchEpisodesBySeasonId(season_id: $season_id) {
//         data {
//             episodes {
//                 label
//                 season_id
//                 episode_number
//                 created_at
//                 updated_at
//                 id
//                 video {
//                     classification_id
//                     video
//                     identifier
//                     visibility
//                     id
//                     episode_id
//                     updated_at
//                     playback_info
//                     otp
//                     category_id
//                     title
//                     featured
//                     category {
//                         description
//                         id
//                         name
//                     }
//                 }
//                 season {
//                     id
//                     title
//                     series_id
//                     folder_id
//                 }
//             }
//         }
//         error {
//             message
//         }
//     }
// }
// `;

export const FETCH_EPISODES_BY_SEASON_ID = gql`
   query FetchEpisodesBySeasonId($season_id:UUID!) {
    fetchEpisodesBySeasonId(season_id: $season_id) {
       data {
            episodes {
                created_at
                episode_number
                id
                label
                season_id
                updated_at
                video {
                    created_at
                    featured
                    id
                    identifier
                    otp
                    playback_info
                    season_folder_id
                    title
                    updated_at
                    upload_status
                    video
                    visibility
                    category {
                        created_at
                        description
                        folder_id
                        group_id
                        id
                        name
                        updated_at
                    }
                    episode {
                        created_at
                        episode_number
                        id
                        label
                        season_id
                        series_id
                        updated_at
                    }
                }
                season {
                    created_at
                    folder_id
                    id
                    label
                    series_id
                    title
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
